module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("Chronology of the Major Events Surrounding Alvin C. York")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("December 13,1887 Alvin C. York is bom to William and Mary Brooks York.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("February 7,1900 Gracie Loretta Williams, Alvin’s future wife, was bom to Asbury and Alice Williams.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("November 17,1911 Alvin’s father is kicked in the chest by a mule. He dies on Christmas Day, his thirtieth wedding anniversary.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("January 1912 Alvin takes full responsibility to provide for his mother and eight younger siblings, his two older brothers having already left home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("January 1, 1915 Alvin surrenders his sinful life to Christ after hearing Melvin H. Russell, a circuit-riding minister to the Church of Christ in Christian Union. He was already being influenced by the teachings of Pastor R. C. Pile, the minister of the Church of Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("1916 Alvin earns $1.60 per day building roads and farming.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("April 6, 1917 United States declares war on Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("June 5, 1917 York receives his induction notice.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("August 28, 1917 York submits the request to be exempt from military service due to religious convictions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("October 5, 1917 District draft board denies the request.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("October 28, 1917 Alvin walks twelve miles to receive "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("physical examination for military service. (He weighs in at 170 pounds and measures seventy-two inches tall.) He is approved for military duty.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("November 14, 1917 Alvin York says farewell to family, friends, and future wife, Gracie Williams. He heads for Camp Gordon, Georgia, where he is registered as Private Alvin C. York, Serial number 1910421, and assigned to the 21st Training Battalion.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("February 1918 He is assigned to Company G, 328th Battalion 1st Platoon, 82nd Division (the All-American Division). Company commander Major George Buxton and Captain E. C. B. Danforth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("March 29, 1918 York receives leave for several days to decide whether or not, as a Christian, he should proceed and go overseas to fight as a Christian.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("April 19, 1918 York leaves Georgia for Camp Upton, New York, before transferring overseas.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("May 1, 1918 York boards a Scandinavian troop transport in Boston and heads for England.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("May 16, 1918 He arrives in Liverpool, England.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("May 21, 1918 He leaves Southampton, England, for French shores.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("October 8, 1918 York performs his amazing feat over the Germans on Hill 223.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("October 8, 1918 York is promoted from Corporal to Sergeant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("February 3, 1919 Brigadier General Lindsey and Major Buxton interview York on location at Hill 223 to have him review the details of the famous battle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("February 11, 1919 York receives the American Distinguished Service Cross during review in front of General Blackjack Pershing. General Pershing attaching the medal, says to York, \"You are the greatest civilian soldier of the war.\"")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("April 8, 1919 York is on hand at the Palace of Versailles, Paris, France, to witness the signing of the peace treaty. York is personally introduced to Premier Clemenceau and Marshal Foch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("April 18, 1919 Good Friday, Alvin York receives the Congressional Medal of Honor at St. Silva, France, by divisional commander Major General George B. Duncan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("May 10, 1919 York boards the ship "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("USS Ohio")]), _vm._v(" and heads for the USA, arriving May 22, 1919.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("May 25- May 28,1919 Alvin York was offered a total of $185,000 dollars in various contracts to promote himself and tell his war story to the American people. He turned down all offers, only wanting to return to his peaceful way of living. He did not feel right selling \"Uncle Sam’s\" uniform.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("May 29, 1919 Alvin York is mustered out of the army and becomes a private citizen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("May 30, 1919 York reaches his beloved family, friends, and future wife, Gracie Williams.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("June 7, 1919 Alvin and Gracie are wed by Tennessee Governor Roberts in York’s peaceful valley, just outside of "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("Pall Mall in a field set aside for the occasion.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("June 5, 1920 Grade delivers their first child, Alvin Jr., but the child dies four days later of hydrocephalus.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("February 14, 1920 The state of Tennessee deeds a beautiful newly-built home to Alvin and Grade on the former land of his ancestors, who settled the Wolf Valley.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("March 18, 1921 2nd son, Alvin Jr., is bom to the Yorks. He is now deceased.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("April 20, 1922 Sam K. Cowan publishes Alvin York’s life story called, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sergeant York and His People.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("July 27, 1923 George Edward York is bom; alive at the time of this writing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("April 13, 1925 Tennessee State legislation approves the Alvin C. York Agriculture Institute in Jamestown, the Fentress County seat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("September 4, 1925 Woodrow Wilson York is bom. He is now deceased.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("February 6, 1928 York receives $10,000 advance money for the publishing of his long- sought personal war journal, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sergeant York: His Own Life Story and War Diary.")]), _vm._v(" This work was accomplished by Australian author, Tom Skeyhill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("1929 Sam Houston, York’s 5th son dies of meningitis before his second birthday.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("April 14,1930 Andrew Jackson York is bom. At the time of this writing, he serves as a park ranger at the Alvin York home "), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("in Pall Mall, TN.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("April 23, 1930 Tom Skeyhill publishes another work called, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Last of the Long Hunters,")]), _vm._v(" a book on the early ancestry of Alvin York and the valley where he lived.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("February 25, 1933 Alvin and Gracie celebrate the arrival of their first girl, christened Betsy Ross York. At the time of this writing, she is still living.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("September 23, 1935 Mary Alice York is bom who now is deceaseds.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("May 7, 1936 York is placed on the Prohibition Party’s ticket as vice-president to Dr. D. Colvin. York declines, unwilling to run against President Roosevelt whom he favored.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("January 9, 1938 Thomas Jefferson York is bom. He dies in the line of duty as deputy sheriff in Pall Mall, TN, on May 7, 1972. At the time of this writing his gracious widow, Margaret, is the hostess of the Alvin York home in Pall Mall, TN.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("July 31, 1939 York, Gracie, Pastor Pile,and Pastor R. D. Brown, along with their lawyer, register a charter for the incorporation of Alvin C. York Bible School in Pall Mall, TN. The school was never fully completed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("March 23, 1940 York signs a contract with producer Jesse Lasky and Parmount Pictures for the rights to film the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sergeant York story.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("November 2, 1940 Gracie York gives birth to a daughter who dies soon after her birth and is left unnamed. This is their last child.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _vm._v("February 26, 1942 Gary Cooper receives the Best Actor of the Year Oscar for role playing Sergeant Alvin York. Upon receiving the award Cooper humbly said, \"It wasn’t Gary Cooper who won this award; it was Sergeant York. Because to the best of my ability, I tried to be Sergeant York.\"")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("May 11, 1943 York files protest with IRS on discrepancies of insufficient income paid for film royalties. This begins an 18-year battle with the IRS.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("February 24, 1954 Alvin York suffered a cerebral hemorrhage, leaving him confined to his bed and wheelchair.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("March 26, 1961 Ed Sullivan, television host, makes an appeal on behalf of Sergeant York, for the American people to rally around him and help pay his on-going IRS bill. The American people immediately began to send money, and within one month, York’s entire bill was paid. Enough money was left to help Grade and York in their retiring age.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("September 2, 1964 Alvin York dies at the age of 76 years old in the Veterans’ Hospital in Nashville, Tennessee.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("September 27, 1984 Gracie York dies at Park View Hospital in Nashville, Tennessee, at the age of 84.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1258805e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Fm02.vue
// module id = 81
// module chunks = 0